export const state = {
  modalViewTransaction: false,
  transactions: [],
  transaction: {}
};

export default {};
